<template>
  <div class="margin-top">
    <el-table
      :data="shopIntegralDetailInfo.details"
      border
      style="width: 100%">
      <el-table-column
        prop="detailId"
        :label="$t('shopIntegralDetail.serialNumber')"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="integralName"
        :label="$t('shopIntegralDetail.pointsAccount')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="detailType"
        :label="$t('shopIntegralDetail.type')"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.detailType === '1001' ? $t('shopIntegralDetail.transferIn') : $t('shopIntegralDetail.transferOut') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        :label="$t('shopIntegralDetail.transactionAmount')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        :label="$t('shopIntegralDetail.currentAmount')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="orderId"
        :label="$t('shopIntegralDetail.transactionNumber')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="remark"
        :label="$t('shopIntegralDetail.remark')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createTime"
        :label="$t('shopIntegralDetail.time')"
        align="center">
      </el-table-column>
    </el-table>

    <el-row class="margin-top">
      <el-col :span="12" :offset="12">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryShopIntegralDetail } from '@/api/shop/integralApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopIntegralDetail',
  data() {
    return {
      shopIntegralDetailInfo: {
        details: [],
        integralId: '',
        integralName: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    async switch(data) {
      this.shopIntegralDetailInfo.integralId = data.integralId
      this.shopIntegralDetailInfo.integralName = data.integralName
      await this.loadShopIntegralDetailData()
    },
    async loadShopIntegralDetailData() {
      try {
        const params = {
          shopId: getShopId(),
          integralId: this.shopIntegralDetailInfo.integralId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        const res = await queryShopIntegralDetail(params)
        this.shopIntegralDetailInfo.details = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('Failed to load shop integral detail:', error)
      }
    },
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadShopIntegralDetailData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
</style>